export const LANE_COUNT = 3;
export const LANE_WIDTH = 2.6; // world units between lane centers
export const LANE_X: readonly number[] = [-LANE_WIDTH, 0, LANE_WIDTH];
export const ROAD_WIDTH = LANE_WIDTH * LANE_COUNT + 1.4;

export type LaneIndex = 0 | 1 | 2;

export function clampLane(i: number): LaneIndex {
  if (i < 0) return 0;
  if (i > 2) return 2;
  return i as LaneIndex;
}
